import * as React from "react";
import { useEffect, useState } from "react";
import fetch from "node-fetch";
import T from "../components/T/T";
import Layout from "../components/Layout/Layout";
import ClaimReward from "../components/ClaimReward/ClaimReward";
import DwaOffers from "../components/DwaOffers/DwaOffers";
import { getLocalQueryParams, getQueryParams } from "../lib/Misc";
import ProductPassport from "../components/ProductPassport/ProductPassport";
import PagePreload from "../components/PagePreload/PagePreload";
import ErrorMessage from "../components/ErrorMessage/ErrorMessage";
import Tabs from "../components/Tabs";
import DwaHero from "../components/DwaHero/DwaHero";
import { GiftOffer } from "../components/GiftOffer";

export default function Dwa() {
    const [loadingPageDisplay, setLoadingPageDisplay] = useState(true);
    const [selectedDisplay, setSelectedDisplay] = useState(null);
    const [showReward] = useState(false);
    const [registerData, setRegisterData] = useState([]);

    const [productPassportDataCarousel, setProductPassportDataCarousel] = useState([]);
    const [productPassportDataSection, setProductPassportDataSection] = useState([]);
    const [productPassportDataHead, setProductPassportDataHead] = useState([]);
    const [productLoaded, setProductLoaded] = useState(true);
    const [loading, setLoading] = useState(true);

    const localParams = getLocalQueryParams();
    let queryParams = getQueryParams();

    if (typeof localStorage !== "undefined" && queryParams && !!queryParams?.code && !!queryParams?.clickId) {
        if (localParams?.code !== queryParams?.code || localParams?.clickId !== queryParams?.clickId) {
            localStorage.removeItem("registerData")
        }
        localStorage.setItem("queryParams", JSON.stringify(queryParams));
    }
    queryParams = !!queryParams && !!queryParams?.code
        ? queryParams
        : typeof localParams !== 'string'
            ? localParams
            : {};

    useEffect(() => {
        const localParams = getLocalQueryParams();
        if (!!localParams?.clickId && (queryParams?.clickId !== localParams?.clickId)) {
            localStorage.setItem("selecteddisplay", null);
            setSelectedDisplay(null);
        } else {
            setSelectedDisplay(localStorage.getItem("selecteddisplay") || null);
        }
        setRegisterData(JSON.parse(localStorage.getItem("registerData")));
        setLoadingPageDisplay(false)
    }, []);

    useEffect(() => {
        if (!productPassportDataCarousel.length || !productPassportDataSection.length) {
            fetchProductData();
        }
    }, [])

    const setData = (resultData) => {
        if (resultData && Array.isArray(resultData)) {
            const filterData = (type) => (item) =>
                item.type === type && !['yes', 'true'].includes(`${item.hide}`.toLowerCase())

            setProductLoaded(true);
            setProductPassportDataCarousel(resultData.filter(filterData('collapsable')));
            setProductPassportDataSection(resultData.filter(filterData('section')));
            setProductPassportDataHead(resultData.filter(item => item.type === 'information'));
            setLoading(false);
        }
        if (!!resultData && (!resultData?.length || !!resultData?.problem)) {
            setProductLoaded(false);
            setProductPassportDataHead(resultData?.problem);
        }
    }

    const fetchProductData = async () => {
        if (queryParams?.code) {
            try {
                const response = await fetch(
                    `${process.env.GATSBY_FABACUS_API_URL || 'https://api.testing.xela.co/v1/'}product/dwa${queryParams.code}`
                );
                setData(await response.json());
            } catch (e) {
                setProductLoaded(false);
            }
        } else {
            setProductLoaded(false);
        }
    };

    const selectDisplayAction = (action) => {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem("selecteddisplay", action);
            setSelectedDisplay(action)
            window.scrollTo(0, 0);
        }
    }

    return (
        <>
            <title>{selectedDisplay !== 'passport' ? (<T>title-qr</T>) : 'Product Passport'}</title>

            {!loadingPageDisplay && (
                <Layout
                    hideHeader={selectedDisplay === null}
                    hideFooter={selectedDisplay === null}
                    selectedDisplay={selectedDisplay}
                    setSelectedDisplay={setSelectedDisplay}
                    extraMainClass={showReward ? 'landing-rewards' : ''}
                    hideHeaderMenu={!!productPassportDataHead?.product}
                    selectDisplayAction={selectDisplayAction}
                >
                    {selectedDisplay === null ? (
                        <PagePreload setSelectedDisplay={selectDisplayAction} />
                    ) : (
                        <>
                            {(queryParams === null || (!!queryParams && !!Object.keys(queryParams)?.length)) ? (
                                <>
                                    {selectedDisplay === 'passport' &&
                                        <ProductPassport
                                            productPassportDataCarousel={productPassportDataCarousel}
                                            productPassportDataSection={productPassportDataSection}
                                            productPassportDataHead={productPassportDataHead}
                                            productLoaded={productLoaded}
                                            loading={loading}
                                            setSelectedTab={selectDisplayAction}
                                        />
                                    }
                                    {selectedDisplay === 'gift' && (
                                        <>
                                            <DwaHero
                                                imgLink={'gift-bg-new.png'}
                                                text={'title-qr'}
                                                customClassname={"gift"}
                                                showTitle={queryParams !== null}
                                                showReward={!registerData?.rewards?.length}
                                            />
                                            <GiftOffer />
                                        </>
                                    )}

                                    {selectedDisplay !== 'passport' && queryParams !== null && (
                                        <ClaimReward showReward={!!registerData && !!registerData.rewards} />
                                    )}
                                </>
                            ) : (
                                <ErrorMessage />
                            )}
                        </>)
                    }
                </Layout>)}
        </>
    );
}
